import { useEffect } from 'react';
import { matchPath, useSearchParams } from 'react-router';

import { VALID_ORIGIN } from '@shared/configs/origin';
import { originAction } from '@shared/stores/origin/originSlice';
import { useAppDispatch } from '@shared/stores/rootTypes';

import { useExtendedRouter } from '../useExtendedRouter';

const useOrigin = () => {
  const { path } = useExtendedRouter();
  const [searchParams] = useSearchParams();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const originUrl = searchParams.get('origin') ?? '';
    const validURL = VALID_ORIGIN.some((url) => !!matchPath(url, originUrl.split('?')[0]));
    if (validURL) {
      dispatch(originAction.setOriginUrl({ key: path, value: encodeURI(originUrl) }));
    }
  }, [path, dispatch, searchParams]);
};

export default useOrigin;
